import {ImageBackground, Text, View} from "react-native";
import React from "react";

import {styles} from "../common/styles";
import {i18n} from "../common/localization";
import {FlagHeader} from "../common/FlagHeader";
import {MainViewHeader} from "./MainViewHeader";

import bg from "../assets/main-bg.jpg";

export const MainView = ({ userName }) => {
    return (
        <View style={styles.container}>
            <ImageBackground source={bg} resizeMode="cover" style={styles.bgImageContainer}>
                <View style={styles.mainViewContainer}>
                    <View style={{flex: 1, justifyContent: "center"}}>
                        <FlagHeader/>
                        <MainViewHeader />
                        <View style={{flex: 1, justifyContent: "center"}}>
                            <Text style={styles.mainViewWelcomeText}>{i18n.t("hiUser", {user: userName})}</Text>
                            <Text style={styles.mainViewWelcomeText}>{i18n.t("welcome")}</Text>
                        </View>
                    </View>
                </View>
            </ImageBackground>
        </View>
    )
}
